import { IS_DEMO_MODE } from '@/utils/demoMode';
import { AlertsComponent } from './Alerts.component';
import { AlertsDemoComponent } from './Alerts.demo.component';

export const AlertsPage = IS_DEMO_MODE ? AlertsDemoComponent : AlertsComponent;
